import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

type ButtonClassProps = {
  chevron?: boolean;
  color?: "accent" | "primary-light" | "primary" | "secondary" | "test";
  iconRight?: React.ReactNode;
  size?: "default" | "small";
  variant?: "transparent" | "outlined" | "solid";
} & React.HTMLAttributes<HTMLElement>;

export type CommonButtonProps = {
  text?: string;
} & ButtonClassProps;

export function createButtonClassNames({
  className,
  color,
  iconRight,
  size,
  variant,
}: ButtonClassProps) {
  return clsx(
    {
      [`button-new`]: true,
      [`button-new--is-accent`]: color === "accent",
      [`button-new--is-neutral`]: color === "primary-light",
      [`button-new--is-primary`]: color === "primary",
      [`button-new--is-secondary`]: color === "secondary",
      [`button-new--is-transparent`]: variant === "transparent",
      [`button-new--is-outlined`]: variant === "outlined",
      [`button-new--is-solid`]: !variant || variant === "solid",
      [`button-new--is-test`]: color === "test",
      [`button-new--is-small`]: size === "small",
      [`button-new--color-override`]: color,
      [`button-new--has-icon-right`]: iconRight,
    },
    className,
  );
}

export function determineIcon({
  chevron,
  iconRight,
}: ButtonClassProps): React.ReactNode {
  if (!chevron && !iconRight) return;

  if (iconRight) {
    return iconRight;
  }
  if (chevron) {
    return <FontAwesomeIcon icon={faChevronRight} />;
  }
  return;
}

type ButtonContentProps = {
  icon?: React.ReactNode;
  text: string;
};

export function ButtonContent({ icon, text }: ButtonContentProps) {
  return (
    <span className="button-new__content">
      <span
        className="button-new__text"
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
      {icon && <span className="button-new__icon">{icon}</span>}
    </span>
  );
}
